import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { CompetitionProps } from "./types";
import { PropertyDefinition, PropertyMappingType, } from "app/library/layout-builder";

export class CompetitionDefinitions extends CmsReactComponent<CompetitionProps> {
    static schemaName = "competition";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "tagsImage",
            text: "Künye Görseli",
            mapping: {
                type: PropertyMappingType.Image
            },
            group: {
                key: "tags",
                title: "Künye Verileri",
                withObject: false,
            }
        },
        {
            name: "tags",
            text: "Künye Verileri",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        name: "title",
                        text: "Başlık",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                    },
                    {
                        name: "content",
                        text: "İçerik",
                        mapping: {
                            type: PropertyMappingType.Html,
                        },
                    },
                ],
            },
            group: {
                key: "tags",
                title: "Künye Verileri",
                withObject: false,
            }
        },
        {
            name: "calendarImage",
            text: "Takvim Görseli",
            mapping: {
                type: PropertyMappingType.Image
            },
            group: {
                key: "calendar",
                title: "Takvim Verileri",
                withObject: false,
            }
        },
        {
            name: "calendar",
            text: "Takvim Verileri",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        name: "title",
                        text: "Başlık",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                    },
                    {
                        name: "content",
                        text: "İçerik",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                    },
                ],
            },
            group: {
                key: "calendar",
                title: "Takvim Verileri",
                withObject: false,
            }
        },
        {
            name: "jury",
            text: "Jüri Üyeleri",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        name: "photo",
                        text: "Fotoğraf",
                        mapping: {
                            type: PropertyMappingType.Image,
                        },
                    },
                    {
                        name: "fullname",
                        text: "Tam adı",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                    },
                    {
                        name: "job",
                        text: "Ünvanı",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                    },
                    {
                        name: "type",
                        text: 'Tipi',
                        mapping: {
                            type: PropertyMappingType.Object,
                            oneOf: [
                                {
                                    key: 1,
                                    text: 'Asli Jüri'
                                },
                                {
                                    key: 2,
                                    text: 'Danışman Jüri'
                                },
                                {
                                    key: 3,
                                    text: 'Yetek Jüri'
                                },
                                {
                                    key: 4,
                                    text: 'Raportör'
                                },
                            ]
                        },
                    },
                    {
                        name: "content",
                        text: "İçerik",
                        mapping: {
                            type: PropertyMappingType.Html,
                        },
                    },
                ],
            },
            group: {
                key: "jury",
                title: "Jüri Verileri",
                withObject: false,
            }
        },
        {
            name: "awardImage",
            text: "Ödül Görseli",
            mapping: {
                type: PropertyMappingType.Image
            },
            group: {
                key: "award",
                title: "Ödül Verileri",
                withObject: false,
            }
        },
        {
            name: "award",
            text: "Ödül Verileri",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        name: "title",
                        text: "Başlık",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                    },
                    {
                        name: "content",
                        text: "İçerik",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                    },
                ],
            },
            group: {
                key: "award",
                title: "Ödül Verileri",
                withObject: false,
            }
        },
        {
            name: "mention",
            text: "Mansiyon Verileri",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        name: "title",
                        text: "Başlık",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                    },
                    {
                        name: "content",
                        text: "İçerik",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                    },
                ],
            },
            group: {
                key: "award",
                title: "Ödül Verileri",
                withObject: false,
            }
        },
        {
            name: "awardDescription",
            text: "Ödül Açıklaması",
            mapping: {
                type: PropertyMappingType.Html
            },
            group: {
                key: "award",
                title: "Ödül Verileri",
                withObject: false,
            }
        },
        {
            name: "mentionDescription",
            text: "Mansiyon Açıklaması",
            mapping: {
                type: PropertyMappingType.Html
            },
            group: {
                key: "award",
                title: "Ödül Verileri",
                withObject: false,
            }
        },
        {
            name: "aboutImage",
            text: "Hakkında Görseli",
            mapping: {
                type: PropertyMappingType.Image
            }
        },
        {
            name: "about",
            text: "Hakkında",
            mapping: {
                type: PropertyMappingType.Html
            }
        },
        {
            name: "faq",
            text: "Sorular",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        name: "title",
                        text: "Başlık",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                    },
                    {
                        name: "content",
                        text: "İçerik",
                        mapping: {
                            type: PropertyMappingType.Html,
                        },
                    },
                ],
            },
            group: {
                key: "faq",
                title: "Sıkça Sorulan Sorular",
                withObject: false,
            }
        },
        {
            name: "documents",
            text: "Bilgi ve Belgeler",
            mapping: {
                type: PropertyMappingType.Html
            }
        },
        {
            name: "contact",
            text: "İletişim",
            mapping: {
                type: PropertyMappingType.Html
            }
        },
        {
            name: "link",
            text: "Link",
            mapping: {
                type: PropertyMappingType.String
            }
        },
    ];
}
